// Grupos de unidades: localidades que para o paciente são "uma só", mas que na
// Feegow têm vários IDs físicos (prédios/andares). O paciente vê um único card; por
// trás, o sistema considera todos os IDs do grupo ao listar médicos e horários.
//
// Escopo atual: apenas Nova Iguaçu - Centro (IDs 0, 10, 11, 22). As demais regiões
// têm uma unidade só e não passam por aqui. O `grupoId` é a chave usada no lugar do
// `unidadeId` ao longo do fluxo (ver pages/Unidade, schedule.class).
export const GRUPOS = {
  NOVA_IGUACU: {
    grupoId: "NOVA_IGUACU",
    nome: "NOVA IGUAÇU - CENTRO",
    regional: "NOVA IGUAÇU",
    unidades: [0, 10, 11, 22],
  },
}

// É um identificador de grupo (string não-numérica), e não um ID de unidade?
export function isGrupoId(value) {
  return typeof value === "string" && Object.prototype.hasOwnProperty.call(GRUPOS, value)
}

// Dado um ID de unidade, retorna o grupo a que ela pertence (ou null).
export function getGrupoByUnidadeId(unidadeId) {
  const id = parseInt(unidadeId, 10)
  return (
    Object.values(GRUPOS).find((g) => g.unidades.includes(id)) || null
  )
}

// Resolve o trecho de unidade vindo do sessionStorage ("unidade".split("::")[1])
// para a lista de IDs numéricos reais. Se for um grupo, devolve todos os IDs do
// grupo; se for um ID único, devolve [id]. Funciona tanto para grupo quanto para
// unidade comum, então pode ser usado em todo o filtro client-side.
export function resolveUnidadeIds(unidadeKey) {
  if (isGrupoId(unidadeKey)) {
    return GRUPOS[unidadeKey].unidades.slice()
  }
  const id = parseInt(unidadeKey, 10)
  return isNaN(id) ? [] : [id]
}

// Resolve o endereço da unidade para exibir na confirmação. O endereço vem do prédio
// do horário escolhido (`slotUnidadeId`) — num grupo, o card não tem endereço próprio,
// então é o slot que define o prédio real. Antes de escolher o horário (ou em unidade
// comum sem grupo), cai para o ID da unidade selecionada. Retorna "" se não encontrar.
export function getEnderecoUnidade() {
  const slotId = sessionStorage.getItem("slotUnidadeId")
  let unidadeId = slotId && slotId !== "undefined" ? slotId : null

  if (!unidadeId) {
    const unidade = sessionStorage.getItem("unidade")
    unidadeId = unidade ? unidade.split("::")[1] : null
  }
  if (!unidadeId) return ""

  try {
    const units = JSON.parse(sessionStorage.getItem("units"))
    const entry = units && units[`unid-${unidadeId}`]
    return (entry && entry.endereco) || ""
  } catch (e) {
    return ""
  }
}

// Um grupo deve aparecer na seleção se qualquer um de seus IDs estiver liberado
// pelo filtro de convênio (`/units?convenio=`). filterUnits undefined = sem filtro.
export function grupoMatchesFilter(grupo, filterUnits) {
  if (!filterUnits) return true
  return grupo.unidades.some((id) => filterUnits.includes(id))
}
